import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { useCallback, useState } from 'react';
import { ClientSelector } from 'src/components/MergeClientModal/client-selector';
import { Client, useConversationParticipant } from 'src/graphql';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { useNotifications } from 'src/utils/hooks';

export const AssociateParticipantWithClientModal = () => {
  const { closeModal } = useModalMethods(Modals.AssociateParticipantWithClientModal);
  const { isOpened, modalProps } = useModalState(Modals.AssociateParticipantWithClientModal);
  const [clientTarget, setClientTarget] = useState<Client | null>(null);
  const { associateParticipantWithClient } = useConversationParticipant();
  const { showErrorAlert, showSuccessAlert } = useNotifications();

  const closeAssociateModal = useCallback(() => {
    closeModal();
    setClientTarget(null);
  }, [closeModal]);

  const handleAssociateParticipant = useCallback(async () => {
    if (!clientTarget?.clientId) {
      showErrorAlert(`Invalid client target ${clientTarget?.clientId}`);

      return;
    }

    if (!modalProps) {
      return;
    }

    const { participant, partnerId } = modalProps;

    closeAssociateModal();

    const response = await associateParticipantWithClient({
      participant,
      client: clientTarget,
      partnerId,
    });

    if (!response?.success) {
      return;
    }

    showSuccessAlert('Participant was associated with the client');
    setClientTarget(null);
  }, [
    associateParticipantWithClient,
    clientTarget,
    closeAssociateModal,
    modalProps,
    showErrorAlert,
    showSuccessAlert,
  ]);

  return (
    <Dialog open={isOpened} onClose={closeAssociateModal} fullWidth>
      <DialogTitle>
        <Stack direction="row" spacing={2}>
          <Typography>Merge Into Existing Client</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <ClientSelector
            deletable
            title="Target Client"
            partnerId={modalProps?.partnerId}
            client={clientTarget}
            setClient={setClientTarget}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleAssociateParticipant} disabled={!clientTarget}>
          Merge into client
        </Button>
      </DialogActions>
    </Dialog>
  );
};
